import { createEmployee } from '../api/companyRecords';
import { buildDemoEmployeePayloads } from './buildDemoEmployeePayloads';
import {
  demoEmployeeIdsStorageKey,
  DEMO_EMPLOYEE_SOURCE,
} from './constants';

export async function seedDemoEmployees({
  companyId,
  ownerId,
  count = 12,
  isSpecialAdmin = false,
}) {
  if (!isSpecialAdmin) {
    throw new Error('Demo employees are available to special admins only.');
  }

  if (!companyId || !ownerId) {
    throw new Error('Company and owner are required to seed demo employees.');
  }

  const demoBatchId = `demo-employees-${Date.now()}`;
  const payloads = buildDemoEmployeePayloads({
    companyId,
    ownerId,
    count,
    demoBatchId,
  });

  const createdIds = [];
  const now = new Date().toISOString();

  for (const payload of payloads) {
    const created = await createEmployee({
      companyId,
      employee: {
        ...payload,
        createdAt: now,
        updatedAt: now,
      },
    });
    createdIds.push(created.id);
  }

  const storageKey = demoEmployeeIdsStorageKey(companyId);
  const existingRaw = window.localStorage.getItem(storageKey);
  const existing = existingRaw ? JSON.parse(existingRaw) : { ownerId, employeeIds: [] };
  const mergedIds = Array.from(new Set([...(existing.employeeIds || []), ...createdIds]));

  window.localStorage.setItem(
    storageKey,
    JSON.stringify({ ownerId, employeeIds: mergedIds })
  );

  return {
    count: createdIds.length,
    demoBatchId,
    source: DEMO_EMPLOYEE_SOURCE,
    managerCount: payloads.filter((p) => p.role === 'manager').length,
    employeeCount: payloads.filter((p) => p.role === 'employee').length,
  };
}
